import { SaveOutlined, CheckOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";
import { $t } from "~/i18n.js";

export const SaveButton = ({ hasSaved, loading, ...args }) => {
  return (
    <Button
      icon={hasSaved ? <CheckOutlined /> : <SaveOutlined />}
      type={hasSaved ? "default" : "primary"}
      loading={loading}
      htmlType="submit"
      {...args}
    >
      {hasSaved ? $t("Opgeslagen") : $t("Opslaan")}
    </Button>
  );
};
